import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/scenario-import-action-types';

import type {List} from 'immutable';

export type ScenarioImportStore = {
    users: List<unknown>;
    organizations: List<unknown>;
};

const initialState = () => {
    return {
        users: Immutable.List(),
        organizations: Immutable.List(),
    };
};

const actionsMap = {
    [actionTypes.SCENARIO_USERS_SUCCESS]: (state, action) => {
        return {
            users: action.data,
        };
    },
    [actionTypes.SCENARIO_ORGANIZATIONS_SUCCESS]: (state, action) => {
        return {
            organizations: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ScenarioImportStore>(initialState(), actionsMap);
